function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#33D5BA",
  fillRule: "evenodd",
  d: "M1.553 0C.695 0 0 .695 0 1.553v18.774c0 .858.695 1.553 1.553 1.553h18.774c.858 0 1.553-.695 1.553-1.553V1.553C21.88.695 21.185 0 20.327 0H1.553zm3.358 6.795c1.048 0 1.898-.85 1.898-1.898 0-1.049-.85-1.898-1.898-1.898s-1.898.85-1.898 1.898.85 1.898 1.898 1.898zm3.636 1.403h3.146v1.44s.854-1.707 3.177-1.707c2.071 0 3.788 1.021 3.788 4.132v6.56h-3.26v-5.765c0-1.835-.98-2.037-1.726-2.037-1.55 0-1.815 1.337-1.815 2.277v5.525h-3.31V8.198zm-1.981 0h-3.31v10.425h3.31V8.198z",
  clipRule: "evenodd"
});
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b3a1b35a5c6bfbd0c6caccd4e15b4ae1.svg";
export { ForwardRef as ReactComponent };